"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = exports.initialValues = {
  show: true,
  teenAttendance: {
    show: true,
    title: 'Teen Attendance',
    description: ''
  },
  teensAttended: {
    show: true,
    title: 'Teens Attended 3+ Sessions',
    description: ''
  },
  caregiverAttendance: {
    show: true,
    title: 'Caregiver Attendance',
    description: ''
  }
};
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Summary Callouts?"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Callout 1"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "teenAttendance.show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Callout 1?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "teenAttendance.title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "teenAttendance.description",
    component: _cccisdFormik.CccisdInput,
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Callout 2"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "teensAttended.show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Callout 2?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "teensAttended.title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "teensAttended.description",
    component: _cccisdFormik.CccisdInput,
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Callout 3"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "caregiverAttendance.show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Callout 3?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "caregiverAttendance.title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "caregiverAttendance.description",
    component: _cccisdFormik.CccisdInput,
    label: "Description"
  }));
};
var _default = exports["default"] = (0, _cccisdLaravelAppdefs.widgetBuilder)({
  initialValues: initialValues
})(Component);